function stringAvatar(name: string | undefined): string {
  if (name == null || typeof name !== 'string' || name.trim().length === 0) {
    return '';
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) {
    const first = parts[0];
    return first.length >= 2 ? `${first[0]}${first[1]}`.toUpperCase() : first[0].toUpperCase();
  }
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export { stringAvatar };